import React, { useEffect, useState } from "react";
import { Form, Modal, Select, Checkbox, Space, Divider } from "antd";
import { useDispatch, useSelector } from "react-redux";

import { getPackageRole } from "../../store/actions/packageRoles";
import { getPackageWithoutPermission } from "../../store/actions/withoutPermissionPackage";

const PackagePermissionForm = ({ visible, onCreate, onCancel, record }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [selectedRoles, setSelectedRoles] = useState([]);

  const packageReducer = useSelector(
    (state) => state.withoutPermissionPackage.list
  );
  const packageRoles = useSelector((state) => state.packageRoles.list);
  console.log("packageReducer===", packageReducer);
  useEffect(() => {
    dispatch(getPackageWithoutPermission());
    dispatch(getPackageRole());
  }, [dispatch]);

  useEffect(() => {
    if (record) {
      form.setFieldsValue({
        name: record.name,
        pId: record.pId,
        prIds: record.prIds || [],
      });
      setSelectedRoles(record.prIds || []);
    } else {
      form.resetFields();
      setSelectedRoles([]);
    }
  }, [record, form]);

  const handlePackageChange = (value) => {
    console.log(`Selected package: ${value}`);
  };

  const handleRoleChange = (checkedValues) => {
    // console.log("Selected roles changed:", checkedValues); // Debugging role selection
    setSelectedRoles(checkedValues);
    form.setFieldsValue({ prIds: checkedValues });
  };

  // const handleSubmit = async () => {
  //   try {
  //     const values = await form.validateFields();
  //     const { pId, prIds } = values;

  //     // Create an array of API calls, one for each selected role
  //     const apiCalls = selectedRoles.map(prId => {
  //       const singlePayload = {
  //         pId: pId,
  //         prId: prId
  //       };
  //       return onCreate(singlePayload); // Call onCreate for each role
  //     });

  //     // Wait for all API calls to complete
  //     await Promise.all(apiCalls);

  //     // Reset form after all calls are successful
  //     form.resetFields();
  //     setSelectedRoles([]);
  //   } catch (error) {
  //     console.log('Validation failed:', error);
  //   }
  // };
  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const { pId, prIds } = values;

      // Create a single payload containing the array of role IDs
      const payload = {
        pId,
        prIds,
      };
      console.log("payload", payload);
      // Call onCreate with the entire payload
      await onCreate(payload);

      // Reset form after successful submission
      form.resetFields();
      setSelectedRoles([]);
    } catch (error) {
      console.log("Validation failed:", error);
    }
  };

  return (
    <Modal
      visible={visible}
      title={record ? "Update Package Permission" : "Add Package Permission"}
      okText="Submit"
      cancelText="Cancel"
      onCancel={() => {
        form.resetFields();
        setSelectedRoles([]);
        onCancel();
      }}
      onOk={handleSubmit}
      width={800}
    >
      <Form
        form={form}
        layout="vertical"
        name="package_permission_form"
        initialValues={record}
      >
        <Form.Item
          name="pId"
          label="Package"
          rules={[{ required: true, message: "Please select a package!" }]}
        >
          <Select placeholder="Select a package" onChange={handlePackageChange}>
            {packageReducer.map((packageItem) => (
              <Select.Option key={packageItem.id} value={packageItem.id}>
                {packageItem.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Divider>Package Roles</Divider>

        <Form.Item
          name="prIds"
          label="Select Roles"
          rules={[
            {
              required: true,
              message: "Please select at least one role!",
              type: "array",
              min: 1,
            },
          ]}
        >
          <Checkbox.Group
            style={{ width: "100%" }}
            value={selectedRoles}
            onChange={handleRoleChange}
          >
            <Space direction="vertical" style={{ width: "100%" }}>
              {packageRoles.map((role) => {
                return (
                  <Checkbox key={role.id} value={role.id}>
                    {role.role}
                  </Checkbox>
                );
              })}
            </Space>
          </Checkbox.Group>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PackagePermissionForm;

// import React, { useEffect, useState } from 'react';
// import { Form, Modal, Select, Checkbox, Space, Divider } from 'antd';
// import { useDispatch, useSelector } from 'react-redux';
// import { getPackage } from '../../store/actions/package';
// import { getPackageRole } from '../../store/actions/packageRoles';

// const PackagePermissionForm = ({ visible, onCreate, onCancel, record }) => {
//   const [form] = Form.useForm();
//   const dispatch = useDispatch();
//   const [selectedRoles, setSelectedRoles] = useState([]);

//   const packageReducer = useSelector((state) => state.packageReducer.list);
//   const packageRoles = useSelector((state) => state.packageRoles.list);

//   useEffect(() => {
//     dispatch(getPackage());
//     dispatch(getPackageRole());
//   }, [dispatch]);

//   useEffect(() => {
//     if (record) {
//       form.setFieldsValue({
//         name: record.name,
//         pId: record.pId,
//         prIds: record.prIds || [],
//       });
//       setSelectedRoles(record.prIds || []);
//     } else {
//       form.resetFields();
//       setSelectedRoles([]);
//     }
//   }, [record, form]);

//   const handlePackageChange = (value) => {
//     console.log(`Selected package: ${value}`);
//   };

//   const handleRoleChange = (checkedValues) => {
//     setSelectedRoles(checkedValues);
//     form.setFieldsValue({ prIds: checkedValues });
//   };

//   const handleSubmit = async () => {
//     try {
//       const values = await form.validateFields();
//       const { pId, prIds } = values;

//       // Create an array of API calls, one for each selected role
//       const apiCalls = selectedRoles.map(prId => {
//         const singlePayload = {
//           pId: pId,
//           prId: prId
//         };
//         return onCreate(singlePayload); // Call onCreate for each role
//       });

//       // Wait for all API calls to complete
//       await Promise.all(apiCalls);

//       // Reset form after all calls are successful
//       form.resetFields();
//       setSelectedRoles([]);
//     } catch (error) {
//       console.log('Validation failed:', error);
//     }
//   };

//   return (
//     <Modal
//       visible={visible}
//       title={record ? "Update Package Permission" : "Add Package Permission"}
//       okText="Submit"
//       cancelText="Cancel"
//       onCancel={() => {
//         form.resetFields();
//         setSelectedRoles([]);
//         onCancel();
//       }}
//       onOk={handleSubmit}
//       width={800}
//     >
//       <Form
//         form={form}
//         layout="vertical"
//         name="package_permission_form"
//         initialValues={record}
//       >
//         <Form.Item
//           name="pId"
//           label="Package"
//           rules={[{ required: true, message: 'Please select a package!' }]}
//         >
//           <Select
//             placeholder="Select a package"
//             onChange={handlePackageChange}
//           >
//             {packageReducer.map((packageItem) => (
//               <Select.Option key={packageItem.id} value={packageItem.id}>
//                 {packageItem.name}
//               </Select.Option>
//             ))}
//           </Select>
//         </Form.Item>

//         <Divider>Package Roles</Divider>

//         <Form.Item
//           name="prIds"
//           label="Select Roles"
//           rules={[{
//             required: true,
//             message: 'Please select at least one role!',
//             type: 'array',
//             min: 1
//           }]}
//         >
//           <Checkbox.Group
//             style={{ width: '100%' }}
//             value={selectedRoles}
//             onChange={handleRoleChange}
//           >
//             <Space direction="vertical" style={{ width: '100%' }}>
//               {packageRoles.map((role) => (
//                 <Checkbox key={role.id} value={role.id}>
//                   {role.role}
//                 </Checkbox>
//               ))}
//             </Space>
//           </Checkbox.Group>
//         </Form.Item>
//       </Form>
//     </Modal>
//   );
// };

// export default PackagePermissionForm;
